module.exports = __webpack_public_path__ + "img/n15.0edbf592.svg";